import React from 'react';
import IconButton from '@mui/material/IconButton';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

function WhatsAppButton() {
  // Replace '1234567890' with the phone number you want to open the chat with.
  // Replace 'Hello%20World' with the message you want to send (URL-encoded).
  const phoneNumber = '+5514999073514';
  const message = 'Olá!';

  const handleClick = () => {
    const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
    window.open(url, '_blank');
  };

  return (
    <>
    <IconButton onClick={handleClick} sx={{float:"left"}}>
        <WhatsAppIcon sx={{float:"left", marginTop:"5px", marginRight:"10px", color:"#ffea00"}} />
    </IconButton>
    </>

  );
};
export default WhatsAppButton;